import React, { useCallback } from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { Button } from '@zocdoc-frontend-common/components-button';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { Arrow } from '@zocdoc-frontend-common/assets-icons/Arrow';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';

// BWA stuff
import SignUpForm from '../../components/SignUpForm';
import DoctorCardHeader from '../../components/DoctorCardHeader';
import LazyLoginModal from '../../components/LazyLoginModal';
import { slideLeftToRightAnimation } from '../../utils/transitionAnimation';

const SignUpPageView = ({
    formattedAppointmentTime,
    locationId,
    loggedInUser,
    onClickLoginLink,
    onCloseLoginModal,
    onSignInSuccess,
    providerId,
    returnUrl,
    sendMetric,
    showRememberMe,
    shouldShowLoginModal,
    goBackToPatientInfo,
    __fakeImportLoginModal,
}) => {
    const userEmail = loggedInUser?.email;
    const canDefaultUserEmail =
        Boolean(loggedInUser?.has_password) && userEmail;
    const defaultEmail = canDefaultUserEmail ? userEmail : null;

    const loginModalProps = {
        defaultEmail,
        onCloseLoginModal,
        onSignInSuccess,
        returnUrl,
        __fakeImportLoginModal,
    };

    const onClickBackToPatientInfo = useCallback(() => {
        sendMetric({
            action: 'Clicked back button',
            category: 'Booking - Sign Up',
            component: 'Back button',
            element: 'Back button',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
            section: 'Sign Up View',
        });
        goBackToPatientInfo();
    }, [goBackToPatientInfo, sendMetric]);

    return (
        <Wrapper>
            <BackButtonDesktop
                data-test="page-body-back-to-patient-info-page-button"
                onClick={onClickBackToPatientInfo}
                variation={Button.VARIATION.LINK}
            >
                <StyledArrow direction={Arrow.direction.left} />
                Back
            </BackButtonDesktop>
            <MainContent>
                <DoctorCardWrapper>
                    <DoctorCardHeader
                        formattedAppointmentTime={formattedAppointmentTime}
                        locationId={locationId}
                        providerId={providerId}
                    />
                </DoctorCardWrapper>
                <SignUpForm
                    data-test="sign-up-form"
                    onClickLoginLink={onClickLoginLink}
                    showRememberMe={showRememberMe}
                />
                {shouldShowLoginModal && (
                    <LazyLoginModal
                        data-test="lazy-login-modal"
                        {...loginModalProps}
                    />
                )}
            </MainContent>
        </Wrapper>
    );
};

const MainContent = styled.div`
    width: 485px;
    max-width: calc(100% - 32px);
    margin: auto;
    ${slideLeftToRightAnimation};
`;

const BackButtonDesktop = styled(Button)`
    display: none;
    color: ${blue100};
    font-size: 15px;
    margin: 0px 0px 0px 40px;
    position: absolute;
    text-align: center;
    ${breakpoint.small} {
        display: block;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledArrow = styled(Arrow)`
    height: 0.8em;
    margin-right: 8px;
`;

const DoctorCardWrapper = styled.div`
    display: block;
`;
export default SignUpPageView;
